var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { AnalyticsTrigger } from '@core-front/analytics';
import { useResponsiveProps } from '@core-front/helper';
import { InputContext } from '@core-front/input-provider';
import PropsChecker from '@core-front/props-checker';
const SelectorCore = (props) => {
    const { responsive } = props, rest = __rest(props, ["responsive"]);
    return (React.createElement(PropsChecker, { componentName: "Selector", componentProps: rest, defaultValueName: "defaultValue", valueName: "value", onChangeNames: "onChange" },
        React.createElement(InputContext.Consumer, null, (value) => (React.createElement(AnalyticsTrigger, { trigger: {
                callback: 'onItemChange',
                id: ([itemId, checked]) => `Selector - ${checked ? 'Check' : 'Uncheck'} - ${itemId}`,
                elementType: 'selector',
                elementId: ([itemId]) => `${itemId}`,
                interactionType: ([, checked]) => `${checked ? 'check' : 'uncheck'}`,
            } }, responsive ? (React.createElement(SelectorResponsiveCore, Object.assign({}, rest, { responsive: responsive, inputIntent: value.input }))) : (React.createElement(SelectorInner, Object.assign({}, rest, { inputIntent: value.input }))))))));
};
const SelectorResponsiveCore = (props) => {
    const { responsive } = props, rest = __rest(props, ["responsive"]);
    const responsiveProps = useResponsiveProps({
        responsive,
    });
    return React.createElement(SelectorInner, Object.assign({}, rest, responsiveProps));
};
export class SelectorInner extends React.Component {
    constructor(props) {
        super(props);
        this.inputsArray = [];
        this.setHoveredItemToState = (item) => {
            this.setState({
                hoveredItemValue: item.value,
            });
        };
        this.removeHoveredItemFromState = () => {
            this.setState({
                hoveredItemValue: undefined,
            });
        };
        this.onChange = (value, checked) => {
            let nextValue;
            if (this.props.inputType === 'checkbox') {
                nextValue = Array.isArray(this.value) ? [...this.value] : [];
                if (checked) {
                    nextValue.push(value);
                }
                else {
                    nextValue = nextValue.filter(item => item !== value);
                }
            }
            else {
                nextValue = value;
            }
            if (!this.isValueControlled()) {
                this.setState({
                    value: nextValue,
                });
            }
            if (this.props.onChange) {
                this.props.onChange(nextValue);
            }
        };
        this.state = {
            value: this.getInitialValue(props.defaultValue),
            hoveredItemValue: undefined,
        };
    }
    get value() {
        return this.isValueControlled(this.props.value) ? this.props.value : this.state.value;
    }
    isValueControlled(value = this.props.value) {
        return !!this.props.onChange && typeof value !== 'undefined';
    }
    isInvalid() {
        return !!this.props.helper && this.props.helper.type === 'error';
    }
    getInitialValue(value) {
        if (value) {
            return value;
        }
        else if (this.props.inputType === 'checkbox') {
            return [];
        }
        else {
            return '';
        }
    }
    BEM() {
        const classArray = ['selector'];
        if (this.props.size) {
            classArray.push('selector--' + this.props.size);
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        if (this.props.hideLabel) {
            classArray.push('selector--hide-label');
        }
        if (this.props.align) {
            classArray.push('selector--' + this.props.align);
        }
        return classArray.join(' ');
    }
    getCheckedStatus(value) {
        if (this.props.inputType === 'checkbox') {
            return value === this.value || this.value.indexOf(value) !== -1;
        }
        else {
            return value === this.value;
        }
    }
    renderFormHelper(helper) {
        if (!this.props.helper) {
            return null;
        }
        const { FormHelper } = this.props.components;
        return React.createElement(FormHelper, Object.assign({}, helper, { className: "selector__form-helper", id: helper.id || `${this.props.id}-helper` }));
    }
    renderLabel(item) {
        const label = React.createElement("span", { className: "selector__item-label" }, item.label);
        if (item.isInactive && !item.disabled) {
            return React.createElement("del", { className: "selector__item-label-strikethrough" }, label);
        }
        return label;
    }
    mapItems() {
        const items = this.props.items.map((item, i) => {
            const itemStyles = {
                background: item.customColor,
            };
            const checked = this.getCheckedStatus(item.value);
            const onChange = () => {
                const isChecked = this.inputsArray[i].checked;
                if (item.disabled) {
                    return;
                }
                this.onChange(item.value, isChecked);
                if (item.onChange) {
                    item.onChange(isChecked);
                }
                if (this.props.onItemChange) {
                    this.props.onItemChange(item.id, isChecked);
                }
            };
            const classArray = ['selector__item'];
            const { GridColumn } = this.props.components;
            const shouldAddEventListeners = this.props.inputIntent === 'mouse' && this.props.showItemLabelNextToLabel;
            if (item.type) {
                classArray.push('selector__item--' + item.type);
            }
            if (item.customColor) {
                classArray.push('selector__item--custom-color');
            }
            if (item.isInactive) {
                classArray.push('selector__item--inactive');
            }
            if (item.className) {
                classArray.push(item.className);
            }
            const onClick = () => onChange();
            const renderIndicatorLabel = () => {
                if (item.children) {
                    return (React.createElement(React.Fragment, null,
                        React.createElement("label", { htmlFor: item.id, className: "selector__indicator-label--has-children" }, item.label),
                        React.createElement("div", { className: "selector__indicator", onClick: onClick },
                            React.createElement("div", { className: "selector__indicator-inner" }, item.children))));
                }
                return (React.createElement("label", { htmlFor: item.id, className: "selector__indicator" },
                    React.createElement("span", { className: "selector__indicator-inner", style: item.customColor ? itemStyles : undefined }, this.renderLabel(item))));
            };
            return (React.createElement(GridColumn, { width: item.itemWidth || this.props.itemWidth, key: i, className: classArray.join(' ') },
                React.createElement("input", { id: item.id, ref: (el) => {
                        if (el && !this.inputsArray.includes(el)) {
                            this.inputsArray.push(el);
                        }
                    }, value: item.value, name: item.name, disabled: item.disabled, checked: checked, type: this.props.inputType, onChange: onChange, className: "selector__input", "aria-label": item.ariaLabel, "aria-invalid": this.isInvalid(), "aria-describedby": this.props.helper ? this.props.helper.id || `${this.props.id}-helper` : undefined, onMouseEnter: shouldAddEventListeners ? () => this.setHoveredItemToState(item) : undefined, onMouseLeave: shouldAddEventListeners ? () => this.removeHoveredItemFromState() : undefined, "aria-required": this.props.inputType === 'checkbox' ? this.props.required : undefined }),
                renderIndicatorLabel()));
        });
        return items;
    }
    getGridProps() {
        let align = [];
        let gutter = this.props.size === 'large' ? 'small' : 'xsmall';
        if (this.props.align === 'center') {
            align = ['center-xs'];
        }
        else if (this.props.align === 'right') {
            align = ['end-xs'];
        }
        if (this.props.gutter) {
            gutter = this.props.gutter;
        }
        return {
            className: 'selector__list',
            gutter,
            align,
            equalHeight: true,
        };
    }
    getItemLabel() {
        const itemValue = this.state.hoveredItemValue || this.value;
        if (itemValue) {
            const selectedItem = this.props.items.find(item => item.value === itemValue);
            return selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.label;
        }
    }
    render() {
        const _a = this.props, { align, components: { Grid }, className, gutter, helper, hideLabel, defaultValue, id, inputIntent, inputType, itemWidth, items, label, onChange, onItemChange, required, size, showItemLabelNextToLabel } = _a, rest = __rest(_a, ["align", "components", "className", "gutter", "helper", "hideLabel", "defaultValue", "id", "inputIntent", "inputType", "itemWidth", "items", "label", "onChange", "onItemChange", "required", "size", "showItemLabelNextToLabel"]);
        return (React.createElement("fieldset", Object.assign({ className: this.BEM(), id: id, role: inputType === 'radio' ? 'radiogroup' : undefined, "aria-required": inputType === 'radio' ? required : undefined }, rest, { 
            // Prevent click events from propagating to parents
            onClick: e => e.stopPropagation() }),
            React.createElement("legend", { className: "selector__label" },
                label,
                showItemLabelNextToLabel ? React.createElement("span", { className: "text-bold" },
                    "\u00A0",
                    this.getItemLabel()) : undefined),
            React.createElement(Grid, Object.assign({}, this.getGridProps()), this.mapItems()),
            helper && this.renderFormHelper(helper)));
    }
}
SelectorInner.defaultProps = {
    inputType: 'radio',
    itemWidth: ['xs'],
};
export default SelectorCore;
